import { AxiosResponse } from 'axios';

import ApiClient from '../../../api/ApiClient';
import { ExamFormEntry, ExamFormGrade } from '../types';
import { AnswerValues } from '../../forms/types';

class ExamFormEntryRepository {
  find(id: number): Promise<AxiosResponse<ExamFormEntry>> {
    return ApiClient.get(`/api/v1/exam-form-entries/${id}`);
  }

  save(id: number, answerValues: AnswerValues) {
    return ApiClient.post(`/api/v1/exam-form-entries/${id}/save`, {
      answers: answerValues,
    });
  }

  submit(id: number) {
    return ApiClient.post(`/api/v1/exam-form-entries/${id}/submit`);
  }

  grade(id: number, grade: ExamFormGrade) {
    return ApiClient.post(`/api/v1/exam-form-entries/${id}/grade`, {
      grade,
    });
  }
}

export default ExamFormEntryRepository;
